<header class="page-header">
  <div *ngIf="appUpdate" class="h-8 flex justify-center items-center bg-stone-900 text-slate-300">
    <span>Version update available.</span> <a class="ml-2 cursor-pointer" (click)="logoutUser()"> Click here to reload the application.</a>
  </div>

  <div class="page-header-bar">
    <div class="page-header-container flex">
      <div class="logo-container allignment flex grow-0 shrink-0">
        <a class="logo-link" target="_blank" href="https://www.lufthansagroup.com/de/home.html">
          <img class="logo-image" src="assets/logos/brand-logo.svg" alt="Lufthansa Technik" />
        </a>
      </div>

      <div class="allignment app-title-column">
        <div class="app-title-container">
          <h1>
            <a class="logo-link" routerLink="/">
              <img class="header-app-logo" src="assets/logos/app-logo.svg" alt="Media Lounge" />
            </a>
          </h1>
          <p class="header-app-claim" i18n>Explore selected images and videos</p>
        </div>
      </div>

      <div *ngIf="screenSizeDetectorService.isLargeScreen; else mobileMenu" class="app-header-menu-container allignment w-[25%] justify-end pr-4">
        <nav class="login-info inline-block px-2">
          <p *ngIf="lang === 'de'" class="language main-nav-link" (click)="switchLanguage('en')">
            <mat-icon class="icon-width material-icons-outlined align-middle">language</mat-icon>
            <span class="align-middle ml-2">English</span>
          </p>
          <p *ngIf="lang === 'en'" class="language main-nav-link" (click)="switchLanguage('de')">
            <mat-icon class="icon-width material-icons-outlined align-middle">language</mat-icon>
            <span class="align-middle ml-2">Deutsch</span>
          </p>
        </nav>

        <div *ngIf="!loggedInUser.email || loggedInUser.email === ANONYMOUS_USER_EMAIL" class="login-info inline-block px-2">
          <p>
            <a (click)="login()" class="main-nav-link">
              <mat-icon class="icon-width material-icons-outlined align-middle">person</mat-icon>
              <span class="align-middle ml-2" i18n>Login for extra features</span>
            </a>
          </p>
        </div>

        <div class="app-header-profile-container">
          <div
            *ngIf="loggedInUser.email && loggedInUser.email !== ANONYMOUS_USER_EMAIL"
            class="login-info px-2 flex items-center space-x-2 cursor-pointer"
            [matMenuTriggerFor]="userPreference"
            data-test-id="user-profile"
          >
            <div class="relative">
              <sp-avatar [user]="loggedInUser" [size]="50" [fontSize]="14" [showToolTip]="false" [clickable]="false"></sp-avatar>
            </div>
          </div>

          <mat-menu #userPreference="matMenu">
            <button mat-menu-item (click)="navigateToProfile()">
              <mat-icon class="material-icons-outlined">account_circle</mat-icon>
              <ng-container i18n>Profile</ng-container>
            </button>
            <button mat-menu-item (click)="logoutUser()" data-test-id="button-logout-profile">
              <mat-icon class="material-icons-outlined">logout</mat-icon>
              <ng-container i18n>Logout</ng-container>
            </button>
          </mat-menu>
        </div>
      </div>

      <ng-template #mobileMenu>
        <div class="app-header-menu-container">
          <sp-mobile-navigation>
            <div class="mobile-nav-primary">
              <button *ngIf="lang === 'de'" class="language main-nav-link" (click)="switchLanguage('en')">
                <mat-icon class="button-icon material-icons-outlined">language</mat-icon>
                <span class="button-text">English</span>
              </button>
              <button *ngIf="lang === 'en'" class="language main-nav-link" (click)="switchLanguage('de')">
                <mat-icon class="button-icon material-icons-outlined">language</mat-icon>
                <span class="button-text">Deutsch</span>
              </button>

              <div *ngIf="!loggedInUser?.email || loggedInUser?.email === ANONYMOUS_USER_EMAIL">
                <a class="main-nav-link" (click)="login()">
                  <mat-icon class="button-icon material-icons-outlined">person</mat-icon>
                  <span class="button-text" i18n>Login for extra features</span>
                </a>
              </div>

              <div *ngIf="loggedInUser?.email && loggedInUser?.email !== ANONYMOUS_USER_EMAIL">
                <div>
                  <button (click)="navigateToProfile()" class="main-nav-link">
                    <mat-icon class="button-icon material-icons-outlined">account_circle</mat-icon>
                    <span class="button-text" i18n>Profile</span>
                  </button>
                </div>

                <div>
                  <button (click)="logoutUser()" data-test-id="button-logout-profile" class="main-nav-link">
                    <mat-icon class="button-icon material-icons-outlined">logout</mat-icon>
                    <span class="button-text" i18n>Logout</span>
                  </button>
                </div>
              </div>

              <nav id="main-nav" aria-label="Main" i18n-ariaLabel tabindex="-1">
                <thehubz-menu-items [menuItemList]="menuItemList"></thehubz-menu-items>
              </nav>
            </div>

            <hr />

            <sp-footer class="mobile-nav-mobile-secondary"></sp-footer>
          </sp-mobile-navigation>
        </div>
      </ng-template>
    </div>
  </div>
</header>
